<template>
  <!-- 备注，弹窗 -->
  <div class="wrap">
    <div class="check-wrap">
      <div
        v-for="tag in tagList"
        :key="tag"
        :class="{
          'check': true,
          'checked': selectedTags.includes(tag)
        }"
        @click="changeTags(tag)"
      >
        {{ tag }}
      </div>
    </div>
    <div class="radio-wrap" @click="changeRadio">
      <div :class="['radio', radioSelected ? 'checked' : '' ]"></div>{{$t('upgrade_page_views_quick_order_quick_order_remark_2140')}}</div>
    <div class="radio-wrap" @click="autoApply = !autoApply">
      <div :class="['radio', autoApply ? 'checked' : '' ]"></div>{{$t('upgrade_page_views_quick_order_quick_order_remark_2141')}}</div>
    <div class="radio-wrap" @click="privately = !privately">
      <div :class="['radio', privately ? 'checked' : '' ]"></div>{{$t('upgrade_page_views_quick_order_quick_order_remark_2142')}}</div>
    <div class="order-tip">
      <GTextarea v-model="tips" :placeholder="$t('upgrade_page_views_quick_order_quick_order_remark_2143')" :maxlength="40"></GTextarea>
    </div>
  </div>
</template>

<script>
import GTextarea from '@/components/common/input/text-area'
export default {
  components: {
    GTextarea
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    tagList: Array,
    initTags: Array,
    initRadio: Boolean,
    initPrivately: Boolean,
    initAutoApply: Boolean,
  },
  data() {
    return {
      selectedTags: [],
      radioSelected: false,
      privately: false,
      autoApply: false,
      tips: ''
    }
  },
  watch: {
    isOpen(open) {
      if (open) {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.initTags) {
        this.selectedTags = (this.initTags || []).slice()
        this.radioSelected = this.initRadio,
        this.privately = this.initPrivately,
        this.autoApply = this.initAutoApply
      }
    },
    changeTags(tag) {
      const index = this.selectedTags.findIndex(m => m === tag)
      if (index > -1) {
        this.selectedTags.splice(index, 1)
      } else {
        this.selectedTags.push(tag)
      }
    },
    changeRadio() {
      this.radioSelected = !this.radioSelected
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrap {
    overflow: hidden;
  }
  .check-wrap {
    overflow: hidden;
    margin: 0 0 0 -7px;
    padding-top: 32px;
    .check {
      box-sizing: border-box;
      float: left;
      width: auto;
      padding: 12px 14px;
      border-radius: 22px;
      margin: 8px 0 0 7px;
      background: #F1F3F6;
      border: 1px solid #DADFE6;
      color: #323D4F;
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      cursor: pointer;
      &.checked {
        background: #FEEBF3;
        border-color: #FA006E;
        color: #DE0062;
      }
    }
  }
  .radio-wrap {
    margin-top: 30px;
    overflow: hidden;
    line-height: 18px;
    color: #323D4F;
    font-size: 14px;
    cursor: pointer;
    .radio {
      box-sizing: border-box;
      width: 18px;
      height: 18px;
      float: left;
      margin-right: 6px;
      border: 2px solid #ADB5C2;
      border-radius: 100%;
      overflow: hidden;
      &.checked {
        border: none;
        background: url('~@/assets/images/radio-checked.png');
        background-size: 100%;
      }
    }
  }
  .order-tip {
    margin-top: 16px;
  }
</style>